import * as maptalks from 'maptalks'
import GPS from './gps_togcj.js'
import store from '@/store/index.js'
let map = null;
let lineDatas = [];
var arrLog = ''

let vm = null
TalksMap.prototype.sendThis = function (_this) {
  vm = _this
}

function TalksMap(mapid) {
  this.map = ''
  if (this.i > 0) {
    clearInterval(this._timer)
  }
  this.pointList = []
  this.Area = 0
  this.MathArea = 0
  this.drawArr = []
  this.lineArr = [] //轨迹或标记点数组
  // this._timer = '',//定时器明称
  this.i = 0,
    this.lineLog = [], //回放路线
    this.speed = 600 //轨迹回放速度
  this.fist = true
    this.TimeOut = 0
  this.lastLinePoints = []
    this.flag = true
  this.btnName = ''
  this.markerLngLat = ''
    this.lastLine = ''
    //		卫星图层
    //2635b736fcd04978596f1e7b0a2ad8d6
    // 辽宁，陕西
  if (window.location.host == 'liaoning.dtwl360.com' || window.location.host == 'sx.dtwl360.com') {
    this.url = "http://t0.tianditu.gov.cn/img_w/wmts?" +
    "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
    "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
    '&tk=bb2d786d54c8bc257f30a850ce6649cd'
    this.wordUrl = "http://t0.tianditu.gov.cn/cia_w/wmts?" +
    "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
    "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
    '&tk=bb2d786d54c8bc257f30a850ce6649cd'
  } else {
    this.url = "http://t0.tianditu.gov.cn/img_w/wmts?" +
    "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
    "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
    "&tk=154ec0f1c3e31efd7806545e0aa9a047"
  this.wordUrl = "http://t0.tianditu.gov.cn/cia_w/wmts?" +
    "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
    "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
    "&tk=154ec0f1c3e31efd7806545e0aa9a047"
  }
  this.baseLayer = new maptalks.TileLayer('base', {
    urlTemplate: this.url,
    subdomains: ['1', '2', '3', '4'],
    attribution: '&copy; <a href="http://osm.org">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/">CARTO</a>'
  })
  this.layer = [
    new maptalks.TileLayer('boudaries', {
      'urlTemplate': this.wordUrl,
      'subdomains': ['1', '2', '3', '4']
    })
  ]
}
var centerLngLat = []
if (window.location.host === 'hebei.dtwl360.com') {
  centerLngLat = [114.502461, 38.045474]
} else if (window.location.host === 'beijing.dtwl360.com') {
  centerLngLat = [116.407387, 39.904179]
} else if (window.location.host === 'hunan.dtwl360.com') {
  centerLngLat = [112.982279, 28.19409]
} else if (window.location.host === 'neimeng.dtwl360.com') {
  centerLngLat = [112.3467, 41.4899]
} else if (window.location.host === 'xiamen.dtwl360.com') {
  centerLngLat = [118.1689, 24.6478]
} else if (window.location.host === 'hubei.dtwl360.com') {
  centerLngLat = [114.3896, 30.6628]
} else if (window.location.host === 'ningbo.dtwl360.com') {
  centerLngLat = [121.51089, 29.862348]
} else if (window.location.host === 'gansu.dtwl360.com') {
  centerLngLat = [103.823557, 36.058039]
} else if (window.location.host === 'qinghai.dtwl360.com') {
  centerLngLat = [101.778916, 36.623178]
} else if (window.location.host === 'bdh.dtwl360.com') {
  centerLngLat = [128.642464, 47.456967]
} else if (window.location.host === 'anhui.dtwl360.com') {
  centerLngLat = [117.283042, 31.86119]
} else if (window.location.host === 'jiangsu.dtwl360.com' || window.location.host === 'huaxia.dtwl360.com') {
  centerLngLat = [120.2234, 33.5577]
} else if (window.location.host === 'xjbt.dtwl360.com') {
  centerLngLat = [87.509259, 43.83667]
} else if (window.location.host === 'xinjiang.dtwl360.com') {
  centerLngLat = [87.9236, 43.5883]
} else if (window.location.host === 'guangdong.dtwl360.com') {
  centerLngLat = [113.280637, 23.125178]
} else if (window.location.host === 'qingdao.dtwl360.com') {
  centerLngLat = [120.382665, 36.066938]
} else if (window.location.host === 'jiangxi.dtwl360.com') {
  centerLngLat = [115.892151, 28.676493]
} else if (window.location.host === 'shandong.dtwl360.com') {
  centerLngLat = [117.019973, 36.671199]
} else if (window.location.host === 'ningxia.dtwl360.com') {
  centerLngLat = [106.258889, 38.472273]
} else if (window.location.host === 'chongqing.dtwl360.com') {
  centerLngLat = [106.550464, 29.563761]
} else if (window.location.host === 'fujian.dtwl360.com') {
  centerLngLat = [119.306239, 26.075302]
} else if (window.location.host === 'zhejiang.dtwl360.com') {
  centerLngLat = [119.2566, 29.2456]
} else if (window.location.host === 'tianjin.dtwl360.com') {
  centerLngLat = [117.190182, 39.125596]
} else if (window.location.host === 'guangxi.dtwl360.com') {
  centerLngLat = [108.320004, 22.82402]
} else if (window.location.host === 'taiwan.dtwl360.com') {
  centerLngLat = [120.883939, 23.266025]
} else if (window.location.host === 'sichuan.dtwl360.com') {
  centerLngLat = [104.065735, 30.659462]
} else if (window.location.host === 'sx.dtwl360.com') {
  centerLngLat = [108.948024,34.263161]
} else if (window.location.host === 'liaoning.dtwl360.com') {
  centerLngLat = [123.429096,41.796767]
} else if (window.location.host === 'yunnan.dtwl360.com') {
  centerLngLat = [102.712251,25.040609]
} else {
  centerLngLat = [102.712251,25.040609]
}
TalksMap.prototype.init = function (container) {
  this.map = new maptalks.Map(container, {
    // center: [116.395645038,39.9299857781],//116.395645038,39.9299857781 108.970611, 34.282389
    // center: centerLngLat,
    center: [106.019973, 38.671199],
    crossOrigin: 'Anonymous',
    zoom: 9,
    maxZoom: 18,
    // pitch: 56,
    // bearing: 30,
    baseLayer: this.baseLayer,
    layers: this.layer
  })
  // if(sessionStorage.getItem('centerLngLat')){
  // 	let center = sessionStorage.getItem('centerLngLat').split(',')
  // 	let Coordinate = {
  // 		x: Number(center[0]),
  // 		y: Number(center[1])
  // 	}
  // 	this.map.setCenter(Coordinate)
  // }
  this.allLineLayer = new maptalks.VectorLayer('lineVector', {
    enableAltitude: false
  }).addTo(this.map)
  this.newLineLayer = new maptalks.VectorLayer('currentNewLine').addTo(this.map)
  this.lastLineLayer = new maptalks.VectorLayer('greenLine').addTo(this.map)
  this.carPoint = new maptalks.VectorLayer("carPoint").addTo(this.map)
  this.picPoint = new maptalks.VectorLayer("picPoint").addTo(this.map)
  this.allLayer = new maptalks.VectorLayer('vector').addTo(this.map)
  this.countyLayer = new maptalks.VectorLayer('countyLayer').setStyle({
    symbol: {
      lineColor: '#00fff6',
      lineWidth: 6,
      polygonFill: '#00fff6',
      polygonOpacity: 0
    }
  }).addTo(this.map)
  this.drawTools = new maptalks.VectorLayer('vectors').addTo(this.map);
}

TalksMap.prototype.addMarker = function (firstLine, List, lastRequestData, workName) {
  let poi = [Number(lastRequestData.lng), Number(lastRequestData.lat)]
  let imgUrl = '';
  if (firstLine) {
    this.allLineLayer.clear()
    this.pointList = []
    this.newLineLayer.clear()
    this.carPoint.clear()

    if (workName && workName == '无人机植保') {
      imgUrl = require('../img/nongji2.png')
    } else {
      imgUrl = require('../img/nongji1.png')
    }

    this.point = new maptalks.Marker(poi, {
      symbol: [{
        markerFile: imgUrl,
        markerWidth: 20,
        markerHeight: 25,
        markerDx: 0,
        markerDy: 0,
        markerOpacity: 1
      }]
    });
    this.point.addTo(this.carPoint);
    this.drawLines(List);
  } else {
    this.carPoint.clear();
    this.playTrackIncremental(List, List.length)
    this.lastRequestData = List[List.length - 1]
    // this.point.setCoordinates(poi)
  }
}

TalksMap.prototype.addMark = function (markPonit, showMarke, showInfo) {
  for (var i = 0; i < markPonit.length; i++) {
    let imgUrl = require('../img/move.png');
    if (showMarke) {
      var point = new maptalks.Marker([Number(markPonit[i].lng), Number(markPonit[i].lat)], {
        symbol: [{
          markerFile: imgUrl,
          markerWidth: 35,
          markerHeight: 40,
          markerDx: 0,
          markerDy: 0,
          markerOpacity: 1
        }]
      }).addTo(this.picPoint);
      if (markPonit[i].area != "") {
        point.setInfoWindow({
          single: false,
          content: '<div class="content equip-content">' + markPonit[i].area + '</div>'
        })
        point.openInfoWindow();
      }

    }

  }
}

TalksMap.prototype.playTrackIncremental = function (pointArray, len) {

  this.newLineLayer.clear()
  let plen = pointArray.length
  let points = []
  for (var i = 0; i < plen; i++) {
    this.pointList.push([Number(pointArray[i].lng), Number(pointArray[i].lat)])
  }

  //向地图上添加线
  this.newLine = new maptalks.LineString(this.pointList, {
    symbol: {
      'lineColor': 'yellow',
      'lineWidth': 2,
      'smoothness': 0.5,
    }
  });

  this.newLine.addTo(this.newLineLayer);
  points = []
  this.fist = false
  this.i = 0
  this.lineLog = pointArray
  this._timer = setInterval(this.onlyAddmarker.bind(this), 100)
}
//	县边界
TalksMap.prototype.drawCountyLine = function (data) {
  this.countyLayer.clear();
  let this_ = this;
  this.polygonCollection = maptalks.GeoJSON.toGeometry(data, function (geometry) {
    /* 鼠标悬停高亮图形 */
    geometry.on('mouseenter', function (e) {
      e.target.updateSymbol({
        'polygonFill': '#00b0f0',
        'lineColor': '#00b0f0',
        'lineWidth': 10,
        'polygonOpacity': 0
      });
    }).on('mouseout', function (e) {
      e.target.updateSymbol({
        'polygonFill': '#00b0f0',
        'lineColor': '#00b0f0',
        'lineWidth': 10,
        'polygonOpacity': 0
      });
    });
    geometry.addTo(this_.countyLayer)

  })
  // this.map.setZoom(10)

}
TalksMap.prototype.drawLines = function (lineArr, flag) {
  this.allLineLayer.clear()
  this.lastLineLayer.clear()
  // this.carPoint.clear()
  var pointData = lineArr.map(function (data) {
    let arr = [Number(data.lng), Number(data.lat)]
    return arr
  });
  var line = new maptalks.LineString(pointData, {
    arrowStyle: null, // arrow-style : now we only have classic
    arrowPlacement: 'vertex-last', // arrow's placement: vertex-first, vertex-last, vertex-firstlast, point
    visible: true,
    editable: true,
    properties: {
      altitude: [400] //seperate altitude for each vertex
    },
    cursor: null,
    shadowBlur: 0,
    shadowColor: 'black',
    draggable: false,
    dragShadow: false, // display a shadow during dragging
    drawOnAxis: null, // force dragging stick on a axis, can be: x, y
    symbol: {
      'lineColor': '#f00',
      'lineWidth': 2,
      'smoothness': 0.5,
    }
  })
  line.addTo(this.allLineLayer);
  this.map.setZoom(16)
}
//	添加轨迹
TalksMap.prototype.drawLine = function (lineArr) {
  this.allLineLayer.clear()
  this.lastLineLayer.clear()
  // this.carPoint.clear()
  var pointData = lineArr.map(function (data) {
    let arr = [Number(data.lng), Number(data.lat)]
    return arr
  });
  var line = new maptalks.LineString(pointData, {
    arrowStyle: null, // arrow-style : now we only have classic
    arrowPlacement: 'vertex-last', // arrow's placement: vertex-first, vertex-last, vertex-firstlast, point
    visible: true,
    editable: true,
    properties: {
      altitude: [400] //seperate altitude for each vertex
    },
    cursor: null,
    shadowBlur: 0,
    shadowColor: 'black',
    draggable: false,
    dragShadow: false, // display a shadow during dragging
    drawOnAxis: null, // force dragging stick on a axis, can be: x, y
    symbol: {
      'lineColor': '#f00',
      'lineWidth': 2,
      'smoothness': 0.5,
    }
  });
  line.addTo(this.allLineLayer);
  if (lineArr.length > 0) {
    var point = new maptalks.Marker([Number(lineArr[0].lng), Number(lineArr[0].lat)], {
      symbol: [{
        markerFile: require('../img/nongji1.png'),
        markerWidth: 20,
        markerHeight: 25,
        markerDx: 0,
        markerDy: 0,
        markerOpacity: 1
      }]
    });
    point.addTo(this.carPoint);
  }
  //		let Coordinate = {
  //			x: Number(lineArr[0].lng),
  //			y: Number(lineArr[0].lat)
  //		}
  //		this.map.setCenter(Coordinate)
  this.map.setZoom(16)
}
//	点击轨迹操作按钮
TalksMap.prototype.playBack = function (pointArray, operationName, markerLastRunPosition, stopFlag, workName, speedNum) {
  this.workName = workName;
  if (operationName === 'start') {
    this.lineLog = pointArray;
    let markerPosition = markerLastRunPosition && markerLastRunPosition > 0 ? markerLastRunPosition : 0
    if (this.fist) {
      var points = []

      if (markerPosition === this.i && stopFlag) {
        var imgUrl = null;
        if (workName && workName == '无人机植保') {
          imgUrl = require('../img/nongji2.png')
        } else {
          imgUrl = require('../img/nongji1.png')
        }
        var point = new maptalks.Marker([this.lineLog[markerPosition].lng, this.lineLog[markerPosition].lat], {
          symbol: [{
            markerFile: imgUrl,
            markerWidth: 20,
            markerHeight: 25,
            markerDx: 0,
            markerDy: 0,
            markerOpacity: 1
          }]
        });
        point.addTo(this.carPoint);

      }
    }
  }
  if (operationName == 'start') { //开始
    clearInterval(this._timer);
    //					this._CarTrack.start()
    this.lastLinePoints = [];
    this.btnName = '';
    this.i = 0
    this.fist = false
    this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum)

  } else if (operationName == 'accelerate') { // 加速
    this.fist = false
    clearInterval(this._timer)
    this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum)
  } else if (operationName == 'slowdown') { //减速
    this.fist = false
    clearInterval(this._timer)
    this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum)
  } else if (operationName == 'stop') { //停止
    this.fist = true
    this.lineLog = []
    this.i = 0
    clearInterval(this._timer)
  } else if (operationName == 'pause') { //暂停
    this.fist = false
    this.i = markerLastRunPosition
    clearInterval(this._timer)
  } else if (operationName == 'continue') { //继续
    this.fist = false
    this.i = markerLastRunPosition
    this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum)
  }
}

TalksMap.prototype.onlyAddmarker = function (i) {
  let extent = this.map.getExtent()
  let extentArr = [
    [extent.xmin, extent.ymin],
    [extent.xmax, extent.ymin],
    [extent.xmax, extent.ymax],
    [extent.xmin, extent.ymax]
  ]
  if (this.carPoint.getCount()) {
    this.carPoint.clear()
  }

  var icon = null;
  if (this.workName && this.workName == '无人机植保') {
    icon = require('../img/nongji2.png')
  } else {
    icon = require('../img/nongji1.png')
  }

  let markPosition = this.i > 0 ? this.i - 1 : 0
  let currentLngLat;
  if (this.lineLog.length > 0) {
    // currentLngLat = [this.lineLog[markPosition].lng, this.lineLog[markPosition].lat]
    // this.markerLngLat = [this.lineLog[0].lng, this.lineLog[0].lat]
    this.allLayer.clear();
    let multiPolygon = new maptalks.Polygon(extentArr, {
      visible: true,
      editable: true,
      cursor: null,
      shadowBlur: 0,
      shadowColor: 'black',
      draggable: false,
      dragShadow: false, // display a shadow during dragging
      drawOnAxis: null, // force dragging stick on a axis, can be: x, y
      symbol: {
        lineColor: '#c4c710',
        lineWidth: 0,
        polygonFill: '#c4c710',
        polygonOpacity: 0
      },

    })
    multiPolygon.addTo(this.allLayer)
    currentLngLat = [this.lineLog[markPosition].lng, this.lineLog[markPosition].lat]
    let inExtent = multiPolygon.containsPoint(new maptalks.Coordinate(currentLngLat))
    if (!inExtent) {
      this.map.setCenter(currentLngLat)
    }
    this.markerLngLat = [this.lineLog[0].lng, this.lineLog[0].lat]
    //		this.marker = new T.Marker(currentLngLat, {
    //			icon: icon
    //		})

    //		let currentPoint = this.map.lngLatToContainerPoint(currentLngLat)
    //
    //		if(currentPoint.x < 100 || currentPoint.y < 100 || currentPoint.x > 1024 || currentPoint.y > 1024) {
    //			this.map.setViewport(new Array(currentLngLat))
    //		}

    //	设置角度偏转以及行驶过的路线变为绿色
    if (markPosition > 0) {
      let lastLngLat = [this.lineLog[markPosition - 1].lng, this.lineLog[markPosition - 1].lat]
      this.angle = getAngle(lastLngLat, currentLngLat);
      this.lastLinePoints.push([Number(this.lineLog[markPosition - 1].lng), Number(this.lineLog[markPosition - 1].lat)]);
    }
    if (this.lastLineLayer.getCount() > 0) {
      this.lastLineLayer.clear()
    }
    this.lastLine = new maptalks.LineString(this.lastLinePoints, {
      symbol: {
        'lineColor': 'yellow',
        'lineWidth': 2,
        'smoothness': 0.5,
      }
    });
    this.lastLine.addTo(this.lastLineLayer);

    var point = new maptalks.Marker(currentLngLat, {
      symbol: [{
        markerFile: icon,
        markerWidth: 20,
        markerHeight: 25,
      }]
    });
    point.addTo(this.carPoint);
    point.updateSymbol({
      markerRotation: 360 - this.angle
    })

    if (this.i >= this.lineLog.length) {
      clearInterval(this._timer)
      this.lineLog = []
      this.i = 0
      this.btnName = "开始"
      vm.$store.state.kName = '';
      vm.$store.state.kName = "end";
      if (document.getElementById("pauseBtnsText") !== null) {
        document.getElementById("pauseBtnsText").innerHTML = '开始';
        document.getElementById("starImgs").src = require('../../../static/bofang/start.png');
      }
      if (document.getElementById("pauseBtns") !== null) {
        document.getElementById("pauseBtns").innerHTML = '开始';
        document.getElementById("starImg").src = require('../../../static/bofang/start.png');
      }
      if (vm.$refs.trackLayer) {
        vm.$refs.trackLayer.$store.state.kName = '';
        vm.$refs.trackLayer.$store.state.kName = 'end';
      }
      this.fist = true;
      this.lastLinePoints = []
      this.lastLineLayer.clear()
      point.setCoordinates(this.markerLngLat)
      // this.i = 0
    } else {
      this.i++;
      //		lineDatas.push(currentLngLat);
    }
  }

}
//传入两个经纬度点得到车辆角度 设置车辆Marker角度
const getAngle = (startPoint, endPoint) => {
  if (!(startPoint && endPoint)) {
    return 0;
  }

  let dRotateAngle = Math.atan2(
    Math.abs(startPoint[0] - endPoint[0]),
    Math.abs(startPoint[1] - endPoint[1])
  );
  if (endPoint[0] >= startPoint[0]) {
    if (endPoint[1] >= startPoint[1]) {} else {
      dRotateAngle = Math.PI - dRotateAngle;
    }
  } else {
    if (endPoint[1] >= startPoint[1]) {
      dRotateAngle = 2 * Math.PI - dRotateAngle;
    } else {
      dRotateAngle = Math.PI + dRotateAngle;
    }
  }
  dRotateAngle = (dRotateAngle * 180) / Math.PI;
  return dRotateAngle;
}

// 圈地块
TalksMap.prototype.area = function (callback) {
  var that = this;
  var config = {
    // 'once': true,
    'properties': {
      index: 1
    },
    'mode': 'Polygon',
    'symbol': {
      'lineColor': '#01A0F3',
      //			'lineColorOpacity':0.5,
      'lineWidth': 2,
      'polygonFill': '#000',
      'polygonOpacity': 0.4,
      'index': 1,
      'parmse': 1
    },
    'vertexSymbol': {
      'markerType': 'ellipse',
      'markerFill': '#34495e',
      'markerLineColor': '#1bbc9b',
      'markerLineWidth': 0,
      'markerWidth': 0,
      'markerHeight': 0
    },
    'labelOptions': {
      'textSymbol': {
        'textName': '12',
        'textFaceName': 'monospace',
        'textFill': '#000',
        'textLineSpacing': 2,
        'textHorizontalAlignment': 'right',
        'textDx': 15,
        'textOpacity': 0
      },
      'boxStyle': {
        'padding': [0],
        'symbol': {
          'markerType': 'square',
          'markerFill': '#000',
          'markerFillOpacity': 0,
          'markerLineColor': '#b4b3b3',
          'markerLineOpacity': 0
        }
      }
    },
    'clearButtonSymbol': [{
      'markerType': 'square',
      'markerFill': '#000',
      'markerLineColor': '#b4b3b3',
      'markerLineWidth': 0,
      'markerWidth': 0,
      'markerHeight': 0,
      'markerDx': 0
    }, {
      'markerType': 'x',
      'markerWidth': 0,
      'markerHeight': 0,
      'markerLineColor': '#fff',
      'markerDx': 0
    }],
    'language': 'zh-CN'
  }

  this.drawTool = new maptalks.AreaTool(config).addTo(this.map);

  //this.map.getLayers()[this.map.getLayers().length-1].setId('tool_'+n)
  // eslint-disable-next-line no-unused-vars
  this.drawTool.on('drawend', (e) => {
    let aSymbol = {
      lineColor: '#01A0F3',
      lineWidth: 2,
      lineOpacity: 1,
      polygonFill: '#000',
      polygonOpacity: 0.4,
      index: 2
    }
    e.geometry.updateSymbol(aSymbol)
    vm.loading = true;


    var ringList = [Number(e.coordinate.x), Number(e.coordinate.y)]
    var markerm = new maptalks.Marker(
      ringList, { // 图形样式
        'symbol': {
          'markerFile': '',
          'markerWidth': 0,
          'markerHeight': 0,
          'markerDx': 0,
          'markerDy': 0,
          'markerOpacity': 0
        }
      }
    ).addTo(this.drawTools)
    var options = {
      id: '1',
      single: false,
      width: 272,
      height: 45,
      custom: false,
      dx: 0,
      dy: 0,
      autoPan: false,
      eventsPropagation: false,
      eventsToStop: false,
      // autoOpenOn: true,
      autoCloseOn: false,
      content: '<div class="content">' + '<button class="drawLayer" id="cancelDraw">取消圈定面积</button><button class="drawLayer" id="handleNext">选择调度农机</button></div>',
      //	content: '人工审核，面积：' + 1 + '亩',

    }
    markerm.setInfoWindow(options)
    markerm.openInfoWindow()


    var cancelDraw = document.getElementById("cancelDraw");
    cancelDraw.onclick = function () {
      that.drawTool.clear()
      that.drawTools.clear()
    }

    var handleNext = document.getElementById("handleNext");
    handleNext.onclick = function () {
      that.drawTool.clear()
      that.drawTools.clear()

      let parmas = []
      e.geometry._coordinates.forEach((item, index) => {
        let arr = [];
        arr.push(item.x, item.y)
        parmas.push(arr)
      })
      callback && callback(parmas);
    }

  })

}
export default TalksMap



// WEBPACK FOOTER //
// ./src/map/js/initMapTalks.js